import { render, staticRenderFns } from "./PlayerConfigThumbnailConfig.vue?vue&type=template&id=44885bf6&"
import script from "./PlayerConfigThumbnailConfig.vue?vue&type=script&lang=js&"
export * from "./PlayerConfigThumbnailConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports